import styled from "styled-components";
import {Input} from "./radioStyles";
import React from "react";
import ToggleSwitchButton from "../buttons/ToggleSwitchButton";

const ListOfNamesInput = (props) => {
    const {name, condition, array, handleChange, selectedValue, toggleChange, openSection} = props

    const displayName = () => {
        if (name === 'stake') {
            return "enjeu"
        }
        if (name.includes('axis')) {
            return "axe"
        }
    }

    const displayArrayOfValue = () => {
        let newArray = []
        if (!!condition) {
            array.forEach((s) => {
                if (s.id === condition.axisId) {
                    newArray.unshift(s)
                } else {
                    newArray.push(s)
                }
            })
        } else {
            newArray = array
        }
        return (
            <div>
                {newArray
                    .map((i, index) => (
                        <label
                            key={index}>
                            <Input
                                key={index}
                                type="radio"
                                checked={parseInt(selectedValue) === i.id}
                                value={parseInt(i.id)}
                                name={name}
                                onChange={handleChange}
                            />
                            <Card>
                                <p>{i.name}</p>
                            </Card>
                        </label>
                    ))}
            </div>
        )
    }

    return (
        <Container>
            <div className={"flex-row w-100 jtc-spc-btw"}>
                <label> Choisir un {displayName()}</label>
                <div>
                    <h6> Sans {displayName()} </h6>
                    <ToggleSwitchButton
                        onChange={toggleChange}
                        name={name}
                    />
                </div>
            </div>
            {openSection &&
            displayArrayOfValue()
            }
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  flex-grow: 1;
  gap: 0.5em;
  border-radius: 10px;
  max-height: 400px;
  border: 1px solid var(--color-grey-06);
  padding: 1em;
  overflow: auto;

  div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5em;
  }

  p {
    font-weight: 600;
  }

  label > input {
    opacity: 0;
    position: absolute;
    top: 0;
  }

  label > input + div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

  label > input:checked + div {
    border: 1px solid var(--color-purple);

    p {
      color: var(--color-purple);
    }
  }

  @media (min-width: 900px) {
    max-height: 200px;

  }
`
const Card = styled.div`
  border-radius: 10px;
  padding: 0.5em;
  background: rgba(166, 172, 181, 0.1);
  border: 1px solid transparent;

  &:hover {
    cursor: pointer;
    border: 1px solid var(--color-purple);

    p {
      color: var(--color-purple);
    }
  }
`

export default ListOfNamesInput

